import React from 'react';
import { memo, useContext } from 'react';
import { Card, Space } from 'antd';
import { SearchResult, Tag } from '../knowledge-base.type';
import TagIcon from '../../knowledge-base-common/components/tag-icon';
import ArticleStatistics from './article-statistics';
import { ComponentContext } from '/react4xp/parts/knowledge-base/knowledge-base';
import { localize } from '/react4xp/mixins/helpers';

type SearchResultsViewProps = {
    query: string;
    articles: SearchResult[];
    tags: Tag[];
};

const SearchResultsView = memo(({ query, articles, tags }: SearchResultsViewProps) => {
    const { clientUrl, translations } = useContext(ComponentContext);

    return (
        <>
            <p
                className="title"
                style={{ marginBottom: '1rem' }}
            >
                {localize('search-results', translations)}: <u>{query}</u>
            </p>
            <Space
                direction="vertical"
                style={{ display: 'flex' }}
            >
                {articles.map((article) => {
                    const tag = tags.find((t) => t.id === article.tagId);
                    return (
                        <Card
                            key={article.id}
                            title={
                                <Space>
                                    <TagIcon
                                        name={tag.icon}
                                        size={20}
                                    />
                                    <p style={{ margin: 0 }}>{tag.title}</p>
                                </Space>
                            }
                        >
                            <ArticleStatistics
                                published={article.updatedAt}
                                views={article.views}
                            />
                            <a
                                href={`${clientUrl}?article=${article.id}`}
                                className="title"
                                style={{ display: 'block', padding: '1rem 0' }}
                            >
                                {article.title}
                            </a>
                            <p
                                className="article-content"
                                dangerouslySetInnerHTML={{
                                    __html: article.content,
                                }}
                            />
                        </Card>
                    );
                })}
            </Space>
        </>
    );
});

export default SearchResultsView;
